import { render, staticRenderFns } from "./ImportExampleTable.vue?vue&type=template&id=3065dbea&scoped=true"
import script from "./ImportExampleTable.vue?vue&type=script&lang=js"
export * from "./ImportExampleTable.vue?vue&type=script&lang=js"
import style0 from "./ImportExampleTable.vue?vue&type=style&index=0&id=3065dbea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3065dbea",
  null
  
)

export default component.exports